export const SpotifyIcon = ({
  width = 26,
  height = 26,
  fill = "none",
  className,
}: {
  fill?: string;
  className?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M28 0C12.5364 0 0 12.5351 0 28C0 43.4649 12.5364 56 28 56C43.4636 56 56 43.4649 56 28C56 12.5351 43.4636 0 28 0ZM41.6606 40.3637C41.2109 41.16 40.3837 41.608 39.5309 41.608C39.1321 41.608 38.7206 41.5083 38.343 41.2983C34.8473 39.3383 31.0376 38.1377 27.0115 37.73C22.977 37.3257 18.9933 37.7351 15.1667 38.9569C13.8897 39.3646 12.5152 38.6591 12.1079 37.38C11.6964 36.0988 12.4049 34.7289 13.6861 34.3191C18.1491 32.8932 22.803 32.4083 27.5036 32.886C32.1957 33.3637 36.6418 34.7637 40.723 37.0512C41.8982 37.7054 42.3182 39.1894 41.6606 40.3637ZM45.0121 31.8589C44.5794 32.6917 43.7309 33.1694 42.8527 33.1694C42.4709 33.1694 42.0891 33.082 41.7285 32.8932C37.4309 30.6549 32.7897 29.2689 27.9236 28.7751C23.0194 28.2732 18.1618 28.7106 13.4782 30.0614C12.1843 30.4288 10.8352 29.6889 10.4661 28.3954C10.0927 27.104 10.8394 25.7549 12.1291 25.382C17.4151 23.8577 22.8964 23.3694 28.4158 23.9294C33.897 24.4877 39.1321 26.0489 43.9812 28.5757C45.1691 29.1972 45.6357 30.6668 45.0121 31.8589ZM46.2254 24.7834C45.8606 24.7834 45.4915 24.7011 45.1394 24.528C40.04 21.9851 34.5545 20.4014 28.8315 19.8206C23.1 19.2343 17.3982 19.6874 11.8788 21.1612C10.5806 21.5057 9.24848 20.7357 8.9006 19.4354C8.55272 18.1368 9.32487 16.8017 10.6273 16.4551C16.7152 14.8294 23.0109 14.3343 29.3279 14.9766C35.6364 15.6151 41.6861 17.3634 47.3115 20.1689C48.5164 20.7688 49.0042 22.232 48.4061 23.4343C47.9818 24.29 47.1206 24.7834 46.2254 24.7834Z"
    />
  </svg>
);
